import React, { Component } from 'react'
import { Link } from 'react-router-dom';
import PlusIcon from '../../icons/plusicon';
import FpgDisableIcon from '../../icons/fpgdisableicon';
import FpgDeleteIcon from '../../icons/fpgdeleteicon';
import FpgpublishIcon from '../../icons/fpgpublishicon';
import FpgeeditIcon from '../../icons/fpgediticon';
import ShowPassIcon from '../../icons/ShowPassIcon';
import ViewIcon from '../../icons/viewIcon';
//moment import
import moment from "moment";

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ActCreators } from '../../redux/bindActionCretor';
import service from '../../services';
import PopUpCustomAll from '../../component/fpg/create/popUpCustomAll';
import ErrorPopUp from '../../component/errorPopUp';
import Slider from "react-slick";
import RecordPresenceBanner from '../../component/RecordPresenceBanner';

const mapStateToProps = state => ({
    LocationEditId: state.locationEditId,
    recordViewers: state.recordViewers,
    getLoginAdminByID: state.getLoginAdminByID,
})
const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActCreators, dispatch)
};

let sub;
class LocationDetail extends Component {
    constructor(props) {
        super(props)

        this.state = {
            locationname: "",
            address: "",
            city: '',
            sta: '',
            zip: '',

            latitude: "",
            longitude: "",
            google_map_link: "",
            satellite_screen_link: "",
            daily_offerings: "",
            amenity: [],
            logo: {
                inSite: "",
                link: ""
            },
            operatingHrs: "",
            avaliableBusRoutes: "",
            venueType: "",
            description: "",
            // isConncession : "",
            accessibility: [],
            accessibilityDescription: "",
            amenitiesFeatures: "",
            hostName: '',
            lastUpdatedBy: "",
            lastUpdatedAt: "",
            errorPopup: false,
            status: "",
            deleteLocationModal: false,
            publishLocationModal: false,
            hide_from_schedule: false,
            disableLocationModal: false,
            hideFromLiveFilm: false,
            showFromLiveFilm: false,
        }
        this._hasLeftPresence = false;
        this.apiserve = new service();
    }

    componentWillUnmount = () => {
        sub.unsubscribe();
        if (!this._hasLeftPresence && this.props.LocationEditId) {
            this.apiserve.sendevent('RecordPresence|leave', {
                modelName: 'location',
                recordId: this.props.LocationEditId
            });
            this._hasLeftPresence = true;
        }
        this.props.ClearRecordPresence();
    }

    componentDidMount() {
        this.props.ClearRecordPresence();
        {
            this.props.LocationEditId &&
                this.getAlldetails();
            this.getDetail();
        }

        // RecordPresence setup - view mode only
        if (this.props.LocationEditId) {
            this.apiserve.sendevent('RecordPresence|join', {
                modelName: 'location',
                recordId: this.props.LocationEditId
            });
        }
    }

    getAlldetails = () => {
        var data = { locationId: this.props.LocationEditId };
        this.apiserve.sendevent("location|getAllDetail", data);
    };

    getDetail = () => {
        sub = this.apiserve.getevent().subscribe((response) => {
            switch (response.event) {
                case "RecordPresence|viewersUpdate":
                    if (response?.data && !response.error) {
                        const currentUserId = this.props.getLoginAdminByID;
                        const viewers = response.data.viewers || [];
                        const currentUserSessionCount = viewers.filter(v => v?.userId === currentUserId).length;
                        const currentUserHasMultipleSessions = currentUserSessionCount > 1;
                        const seenIds = new Set();
                        const filteredViewers = viewers
                            .filter(v => {
                                if (v?.userId === currentUserId) {
                                    return currentUserHasMultipleSessions;
                                }
                                return true;
                            })
                            .filter(v => {
                                if (seenIds.has(v?.userId)) return false;
                                seenIds.add(v?.userId);
                                return true;
                            })
                            .map(v => ({
                                userId: v?.userId,
                                userName: `${v?.fname || ''} ${v?.lname || ''}`.trim() || 'Unknown User'
                            }));
                        this.props.SetRecordViewers(filteredViewers);
                    }
                    break;
                case "location|getAllDetail":
                    if (!response.error) {
                        this.setState({
                            eventiveId:response?.data?.eventiveId,
                            locationname:response?.data?.name,
                            address:response?.data?.street,
                            city: response?.data?.city?.name,
                            sta: response?.data?.state,
                            zip: response?.data?.zip,
                            operatingHrs:response?.data?.operatingHrs,
                            avaliableBusRoutes:response?.data?.avaliableBusRoutes,
                            venueType:response?.data?.venueType?.name,
                            description:response?.data?.description,
                            // isConncession :response?.data?.isConncession,
                            accessibility: response ?.data ?.accessibility,
                            accessibilityDescription: response?.data?.accessibilityDescription,
                            images:response.data.images,
                            status: response ?.data ?.status,
                            hideFromLive: response ?.data ?.hideFromLive,
                            hide_from_schedule: response?.data?.hideFromSchedule,
                            latitude: response ?.data ?.latitude,
                            longitude: response ?.data ?.longitude,
                            google_map_link: response ?.data ?.google_map_link,
                            satellite_screen_link: response ?.data ?.satellite_screen_link,
                            amenity: response ?.data ?.amenity,
                            amenitiesFeatures: response ?.data ?.amenitiesFeatures,
                            daily_offerings: response ?.data ?.daily_offerings,
                            hostName: response ?.data ?.hostName,
                            maxWaitListSlots: response ?.data ?.maxWaitListSlots,
                            getLastUpdated: response ?.data,
                            lastUpdatedBy: response ?.data ?.updatedBy,
                            lastUpdatedAt: response ?.data ?.updatedAt,
                        })
                    }
                    break;
                case "location|updateStatus":
                    if (!response.error) {
                        this.props.history.push('/locations')
                    }
                    else {
                        this.setState({
                            errorPopup: true,
                            errorMsg: response.data.error ? response.data.error : response.data
                        })
                    }
                    break;
                case "location|remove":
                    if (!response.error) {
                        this.props.history.push('/locations')
                    }
                    else {
                        this.setState({
                            errorPopup: true,
                            errorMsg: response.data.error ? response.data.error : response.data
                        })
                    }
                    break;

                default:
                    break;
            }
        })
    }

    AddLocation = () => {
        this.props.LocationEditData("")
        this.props.history.push('/create-location');
    }

    EditLocation = () => {
        this.props.history.push(`/create-location/${this.props.LocationEditId}/Edit`);
    }

    closeModal = () => {
        this.setState({
            deleteLocationModal: false,
            publishLocationModal: false,
            disableLocationModal: false,
            hideFromLiveLocation: false,
            showFromLiveLocation: false,
        })
    }

    // Delete location 
    deleteLocation = () => {
        this.setState({
            deleteLocationModal: true
        })
    }
    deleteLocationYes = () => {
        this.apiserve.sendevent("location|remove", {
            locationId: this.props.LocationEditId
        });
    }

    // Publish Location
    publishLocation = () => {
        this.setState({
            publishLocationModal: true
        })
    }

    publishLocationYes = () => {
        this.apiserve.sendevent("location|updateStatus", {
            locationId: this.props.LocationEditId,
            hideFromLive:this.state.hideFromLive,
            status: 1
        });
    }

    // Disable location

    disableLocation = () => {
        this.setState({
            disableLocationModal: true
        })
    }

    disableLocationPopupYes = () => {
        this.apiserve.sendevent("location|updateStatus", {
            locationId: this.props.LocationEditId,
            hideFromLive:this.state.hideFromLive,
            status: 2
        });
    }

    hideFromLiveLocation = () => {
        this.setState({
          hideFromLiveLocation: true
        })
      }
    
      hideFromLiveLocationPopupYes = () => {
        this.apiserve.sendevent("location|updateStatus", {
          locationId: this.props.LocationEditId,
          status:this.state.status,
          hideFromLive: true
        });
      }
    
      showFromLiveLocation = () => {
        this.setState({
          showFromLiveLocation: true
        })
      }
    
      showFromLiveLocationPopupYes = () => {
        this.apiserve.sendevent("location|updateStatus", {
          locationId: this.props.LocationEditId,
          status:this.state.status,
          hideFromLive: false
        });
      }

    errorMsgPopup = () => {
        this.setState({
          errorPopup: false,
          deleteLocationModal: false,
        })
      }

    EditLocation = () => {
        this.props.history.push(`/create-location/${this.props.LocationEditId}/Edit`);
    }
      
    render() {
        const { getLastUpdated } = this.state
        var updateAt = new Date(this.state.lastUpdatedAt)
        var hour = moment(updateAt).format('h')
        var minutes = moment(updateAt).format('mm')
        var state = moment(updateAt).format('A')
        var settings = {
            customPaging: function (i) {
              return <a>{i + 1}</a>;
            },
            dots: true,
            arrows: false,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
          };

        const { locationname, address, city, sta, zip, hide_from_schedule, operatingHrs, avaliableBusRoutes, venueType, description, isConncession, accessibility, accessibilityDescription, latitude, longitude, google_map_link, satellite_screen_link, amenity, amenitiesFeatures, daily_offerings, hostName, eventiveId, maxWaitListSlots} = this.state;


        return (
            <div className="right_side_wrapper ">
                <ul className="fpg_admin_tab disp_flex">
                    <li className="active">
                        <p className="uppercase text_center">
                            <div>LOCATION DETAILS</div>
                            {/* <Link to="/create-location" ><PlusIcon /></Link> */}
                            <span onClick={this.AddLocation} ><PlusIcon /></span>
                        </p>
                    </li>
                </ul>
                <div className="back_date d_flex d_flex_align_center d_flex_justify_spacebt">
                    <Link className="back_link" to="/locations">
                        <svg width="5" height="10" viewBox="0 0 5 10" fill="none"> <path d="M5 0L0 5L5 10V0Z" fill="black" /> </svg>
                        Back to List
                    </Link>
                    <p className="update_date">
                        Last Update: {hour}:{minutes} {state} -  {moment(this.state.lastUpdatedAt).format('MM/DD/YY')} by {(this.state.lastUpdatedBy && this.state.lastUpdatedBy.fname) + ' ' + (this.state.lastUpdatedBy && this.state.lastUpdatedBy.lname)}
                    </p>
                </div>
                <RecordPresenceBanner activeViewers={this.props.recordViewers} />
                <div className="fpg_tabcontent pl_15 about_sundance">
                    <div className="fpg_edits_links d_flex d_flex_align_center d_flex_justify_center">
                        <Link className="d_flex d_flex_align_center d_flex_justify_center"  onClick={() => this.EditLocation()}>
                            <FpgeeditIcon />
                            EDIT
                        </Link>
                        {this.state.status === 1 ?

                            <Link className="d_flex d_flex_align_center d_flex_justify_center" onClick={() => this.disableLocation()} >
                                <FpgDisableIcon /> DISABLE
                        </Link>
                            :
                            <Link className="d_flex d_flex_align_center d_flex_justify_center" onClick={() => this.publishLocation()} >
                                <FpgpublishIcon /> PUBLISH
                        </Link>
                        }
                        {this.state.hideFromLive === true ?
                            <Link className="d_flex d_flex_align_center d_flex_justify_center sd_show_hide_btn" onClick={() => this.hideFromLiveLocation()}>
                                <ViewIcon /> Show On Live
                            </Link>
                            :
                            <Link className="d_flex d_flex_align_center d_flex_justify_center sd_show_hide_btn" onClick={() => this.showFromLiveLocation()}>
                                <ShowPassIcon /> Hide From Live
                            </Link>
                        }
                        <Link className="d_flex d_flex_align_center d_flex_justify_center" onClick={() => this.deleteLocation()} >
                            <FpgDeleteIcon />
                            DELETE
                        </Link>

                    </div>
                    <div className="d_flex">
                        <div className="location_col feature_col">
                            <div className="data_list">
                                <ul>
                                    <li className="d_flex">
                                        <label className="font_600">Eventive ID</label>
                                        <span>{eventiveId}</span>
                                    </li>
                                    <li className="d_flex">
                                        <label className="font_600">Hide From Schedule</label>
                                        <span>{hide_from_schedule ? 'Yes' : 'No'}</span>
                                    </li>
                                    <li className="d_flex">
                                        <label className="font_600">Location Name</label>
                                        <span>{locationname}</span>
                                    </li>
                                    <li className="d_flex">
                                        <label className="font_600">Street Address</label>
                                        <span>{address}</span>
                                    </li>
                                    <li className="d_flex">
                                        <label className="font_600">City</label>
                                        <span>{city}</span>
                                    </li>
                                    <li className="d_flex">
                                        <label className="font_600">State</label>
                                        <span>{sta}</span>
                                    </li>
                                    <li className="d_flex">
                                        <label className="font_600">Zip Code</label>
                                        <span>{zip}</span>
                                    </li>
                                    <li className="d_flex">
                                        <label className="font_600">Latitude</label>
                                        <span>{latitude}</span>
                                    </li>
                                    <li className="d_flex">
                                        <label className="font_600">Longitude</label>
                                        <span>{longitude}</span>
                                    </li>
                                    <li className="d_flex">
                                        <label className="font_600">Google Maps Link</label>
                                        <span>{google_map_link}</span>
                                    </li>
                                    <li className="d_flex">
                                        <label className="font_600">Satellite Screen Link</label>
                                        <span>{satellite_screen_link}</span>
                                    </li>
                                </ul>
                            </div>
                            <div className="field_row mb_25">
                                <label className="font_600 color_black">Operating Hours</label>
                                <div className="editor_view" dangerouslySetInnerHTML={{ __html: operatingHrs }} />
                            </div>
                            <div className="field_row mb_25">
                                <label className="font_600 color_black">Transportation</label>
                                <div className="editor_view" dangerouslySetInnerHTML={{ __html: avaliableBusRoutes }} />
                            </div>
                            <div className="data_list">
                                <ul>
                                    <li className="d_flex">
                                        <label className="font_600">Venue Type</label>
                                        <span>{venueType}</span>
                                    </li>
                                </ul>
                            </div>
                            <div className="field_row mb_25">
                                <label className="font_600 color_black">Daily Offerings</label>
                                <div className="editor_view" dangerouslySetInnerHTML={{ __html: daily_offerings }} />
                            </div>
                        </div>
                        <div className="location_col feature_col">
                            <div className="field_row mb_25">
                                <label className="font_600 color_black">Location Description</label>
                                <div className="editor_view" dangerouslySetInnerHTML={{ __html: description }} />
                            </div>
                            <div className="data_list">
                                <ul>
                                    {/* <li className="d_flex">
                                            <label className="font_600">Concessions Available?</label>
                                            <span>{isConncession ? 'Active' : 'Inactive'}</span>
                                        </li> */}
                                    <li className="d_flex">
                                        <label className="font_600" style={{ width: "94px" }}>Amenities</label>
                                        <span>
                                            {amenity.map((item) => {
                                                return (
                                                    <p>{item ?.name}</p>
                                                )
                                            })}
                                        </span>
                                    </li>
                                    <li className="d_flex">
                                        <label className="font_600" style={{ width: "94px" }}>Accessibility Accommodations</label>
                                        <span>
                                            {accessibility.map((item) => {
                                                return (
                                                    <p>{item ?.name}</p>
                                                )
                                            })}
                                        </span>
                                    </li>
                                    <li className="d_flex">
                                        <label className="font_600">Host Name</label>
                                        <span>{hostName}</span>
                                    </li>
                                    <li className="d_flex">
                                        <label className="font_600">Maximum Waitlist Slots</label>
                                        <span>{maxWaitListSlots}</span>
                                    </li>
                                </ul>
                            </div>
                            <div className="field_row mb_25">
                                <label className="font_600 color_black">Amenities & Features</label>
                                <div className="editor_view" dangerouslySetInnerHTML={{ __html: amenitiesFeatures }} />
                            </div>
                            <div className="field_row mb_25">
                                <label className="font_600 color_black">Accessibility</label>
                                <div className="editor_view" dangerouslySetInnerHTML={{ __html: accessibilityDescription }} />
                            </div>
                            <div className='location_img_view'>
                                <label></label>
                                <Slider {...settings}>
                                    {this.state.images &&
                                    this.state.images.map((item) => (
                                        <div>
                                        <div className="media_image">
                                            <img
                                            src={
                                                item.inSite ? this.apiserve.imageUrl + item.inSite :
                                                item.link ? item.link :
                                                    '/images/image-placeholder.png'
                                            }
                                            alt="image"
                                            />
                                        </div>
                                        </div>
                                    ))}
                                </Slider>
                            </div>
                        </div>
                    </div>
                </div>



               

                {this.state.deleteLocationModal ?
                    <PopUpCustomAll
                        HeaderName='Delete?'
                        insideDetails='You are about to delete an location and this action is permanent'
                        insideData='Do you want to proceed?'
                        popupState={this.closeModal}
                        yesPopUp={this.deleteLocationYes}
                    />
                    : ''}

               {this.state.errorPopup ?
                    <ErrorPopUp
                        errorMsg={this.state.errorMsg}
                        errorMsgPopup={this.errorMsgPopup}
                    />
                    : ''
                }

                {this.state.disableLocationModal ?
                    <PopUpCustomAll
                        HeaderName='Disable?'
                        insideDetails='You are about to disable an item, which will temporarily make it unavailable on the production site'
                        insideData='Do you want to proceed?'
                        popupState={this.closeModal}
                        yesPopUp={this.disableLocationPopupYes}
                    />
                    : ''}
                {this.state.publishLocationModal ?
                    <PopUpCustomAll
                        HeaderName='Publish Changes'
                        insideDetails='Saving the current changes will publish it to the production site'
                        insideData='Do you want to proceed?'
                        popupState={this.closeModal}
                        yesPopUp={this.publishLocationYes}
                    />
                    : ''}
                {this.state.hideFromLiveLocation ?
                    <PopUpCustomAll
                    HeaderName='Show On Live?'
                    insideDetails='Saving the current changes will show it to the site'
                    insideData='Do you want to proceed?'
                    popupState={this.closeModal}
                    yesPopUp={this.showFromLiveLocationPopupYes}
                    />
                    : ''
                }
                {this.state.showFromLiveLocation ?
                    <PopUpCustomAll
                    HeaderName='Hide From Live'
                    insideDetails='Saving the current changes will hide it from the site'
                    insideData='Do you want to proceed?'
                    popupState={this.closeModal}
                    yesPopUp={this.hideFromLiveLocationPopupYes}
                    />
                    : ''
                }
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LocationDetail)